import React, { useState } from "react";
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { isUserLoggedIn } from '../utils/apiUtils';

interface IUserData {
    id: number,
    username: string,
    email: string
}

const UserProfile: React.FC = () => {
    let { usernameParam } = useParams();

    const navigate = useNavigate();

    const [userData, setUserData] = useState<IUserData>();

    useEffect(() => {
        async function fetchData() {
            try {
                const loggedIn = await isUserLoggedIn();
                if (!loggedIn) {
                    navigate("/");
                    return;
                }
    
                const res = await fetch(`https://api.motivul.com/api/user/${usernameParam}`);
                const data = await res.json();
                if (data.username) {
                    setUserData(data);
                }
            } catch (error) {
                // Handle any errors
                console.error('Error occurred while checking user login status:', error);
            }
        }
    
        fetchData();
    }, []);

    return (
        <>
            {userData?.username ? <div>This is { userData.username }'s profile page. They have the id of { userData.id }. Their email is { userData.email }</div> : <div>Profile not found</div>}
        </>
    );
};

export default UserProfile;
